export default "__VITE_ASSET__4GnFxhyW__"